import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-file-uploads',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './file-uploads.component.html',
    styleUrl: './file-uploads.component.css'
})
export class FileUploadsComponent implements OnInit {
  @Input() fields: any;
  @Input() formGroup!: FormGroup;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  selectedFileName: any[] = [];
  isDragOver: boolean = false;
  previewUrl: string | null = null;

  ngOnInit() {
    const existingValue = this.formGroup?.get(this.fields.fieldName)?.value;
    if (existingValue && typeof existingValue === 'string') {
      this.previewUrl = existingValue;
      const fileName = existingValue.split('/').pop() || 'icon';
      const extension = fileName.split('.').pop() || '';
      this.selectedFileName = [{
        name: fileName,
        extension: extension
      }];
    }
  }

  openFilePicker(event?: Event) {
    if (event) event.stopPropagation();
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.handleFile(file);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave() {
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;

    const file = event.dataTransfer?.files[0];
    this.handleFile(file);
  }

  handleFile(file: File | undefined) {
    if (!file) return;

    const fileName = file.name;
    const extension = (fileName.split('.').pop() || '').toLowerCase();

    if (file.size > 1024 * 1024) {
      alert('File size exceeds the 1 MB limit.');
      return;
    }

    const fileObj: any = {
      name: fileName,
      extension: extension,
      size: file.size
    };

    if (['png', 'jpg', 'jpeg', 'svg', 'webp'].includes(extension)) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
        fileObj.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    } else {
      this.previewUrl = null;
    }

    this.selectedFileName = [fileObj];

    const control = this.formGroup?.get(this.fields.fieldName);
    if (control) {
      control.setValue(file);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }

  removeFile(event?: Event): void {
    if (event) event.stopPropagation();
    this.selectedFileName = [];
    this.previewUrl = null;

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }

    const control = this.formGroup?.get(this.fields.fieldName);
    if (control) {
      control.setValue(null);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }
}
